import { render } from "./SaveFormDlg.vue?vue&type=template&id=0a515c6a&scoped=true"
import script from "./SaveFormDlg.vue?vue&type=script&lang=js"
export * from "./SaveFormDlg.vue?vue&type=script&lang=js"

import "./SaveFormDlg.vue?vue&type=style&index=0&id=0a515c6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a515c6a"]])

export default __exports__